export enum PaymentErrorMessage {
  card_declined = 'Payment unsuccessful. Your card issuer has declined this transaction. Please contact them to resolve or choose another payment method. You can also',
  card_expired = 'Payment unsuccessful. Card is expired. Please choose another payment method. You can also',
  card_inactive = 'Payment unsuccessful. Please make sure your card is active or choose another payment method. You can also',
  card_info_issue = 'Payment unsuccessful. Please make sure the CVV, card number, and other information entered is correct. You can also',
  expired_quote = 'The quote has expired. Please ',
  general_failure = 'Payment unsuccessful. Please',
  no_funds_or_limit_exceeded = 'Payment unsuccessful. Your transaction exceeds your payment limit or there are insufficient funds. Please review your account settings or choose another payment method. You can also',
}

export const BraintreeErrorSchemaMap = {
  'Insufficient Funds': {
    message: PaymentErrorMessage.no_funds_or_limit_exceeded,
  },
  'Limit Exceeded': {
    message: PaymentErrorMessage.no_funds_or_limit_exceeded,
  },
  'Processor Declined - Fraud Suspected': {
    message: PaymentErrorMessage.card_declined,
  },
  'Processor Declined': {
    message: PaymentErrorMessage.card_declined,
  },
  'Declined - Call Issuer': {
    message: PaymentErrorMessage.card_declined,
  },
  Declined: {
    message: PaymentErrorMessage.card_declined,
  },
  "Funding Instrument In The PayPal Account Was Declined By The Processor Or Bank, Or It Can't Be Used For This Payment":
    {
      message: PaymentErrorMessage.card_declined,
    },
  'Cannot Authorize at this time (Policy)': {
    message: PaymentErrorMessage.card_declined,
  },
  'Do Not Honor': {
    message: PaymentErrorMessage.card_declined,
  },
  'Security Violation': {
    message: PaymentErrorMessage.card_declined,
  },
  'Cannot use payment_method_nonce more than once.': {
    message: PaymentErrorMessage.card_declined,
  },
  'Cannot Authorize at this time (Life cycle)': {
    message: PaymentErrorMessage.card_declined,
  },
  'Closed Card': {
    message: PaymentErrorMessage.card_inactive,
  },
  'Call Issuer. Pick Up Card.': {
    message: PaymentErrorMessage.card_inactive,
  },
  'Card Not Activated': {
    message: PaymentErrorMessage.card_inactive,
  },
  'Gateway Rejected: cvv': {
    message: PaymentErrorMessage.card_info_issue,
  },
  'Card Issues Declined CVV': {
    message: PaymentErrorMessage.card_info_issue,
  },
  'Invalid Credit Card Number': {
    message: PaymentErrorMessage.card_info_issue,
  },
  'No Account': {
    message: PaymentErrorMessage.card_info_issue,
  },
  'Expired Card': {
    message: PaymentErrorMessage.card_expired,
  },
};

const InternalErrorSchemaMap = {
  'Expired Quote': {
    message: PaymentErrorMessage.expired_quote,
  },
  'Generic Error': {
    message: PaymentErrorMessage.general_failure,
  },
};

export const getInternalFailureReason = (error: any) => {
  const expiredQuote = error?.message?.includes('is expired, expiration time');
  return expiredQuote
    ? InternalErrorSchemaMap['Expired Quote'].message
    : InternalErrorSchemaMap['Generic Error'].message;
};

export const getBraintreeFailureReason = (error: any) => {
  if (!error?.message?.includes('Failed to process the payment:')) {
    return;
  }
  const reason = error?.message?.substring(error?.message?.indexOf('-') + 1);
  const trimmedReason = reason?.trim();
  return BraintreeErrorSchemaMap[trimmedReason].message;
};

export const getFailureReason = (error: any) => {
  if (!error?.message) {
    return PaymentErrorMessage.general_failure;
  }

  let reason =
    getBraintreeFailureReason(error) ||
    getInternalFailureReason(error) ||
    PaymentErrorMessage.general_failure;
  return reason;
};
